import { store } from 'react-notifications-component';

var showNotification = {
    error: function error(msg, duration){
        store.addNotification({
            title: "Error!",
            message: msg,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
            duration: duration,
            onScreen: true
            }
        });
    },
    success: function sucess(msg, duration){
        store.addNotification({
            title: "Success!",
            message: msg,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: duration,
              onScreen: true
            }
        });
    }
}

export default showNotification;